<template>
  <div>
    <h6 v-translate>In App Commission View</h6>
    <div v-if="!editing">
      <h5>
        {{currentCommission}}
        <b-button size="sm" variant="link" @click.prevent="editing = true" class="p-0">
          <font-awesome-icon icon="edit" size="1x" />
        </b-button>
      </h5>
    </div>
    <form @submit.prevent="setCourierCommissionPercentage" class="text-left" v-else>
      <b-alert variant="light" show style="border: 1px solid #ddd">
      <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; right: 0;border-radius: 3px;" @click.prevent="editing = false; emitDone()" v-if="editing === true">×</span>
      <ul class="no-bullet mb-0">
        <li>
          <b-form-radio-group v-if="userVisibleCommission" v-model="customVisibleComission" stacked>
            <b-form-radio :value="false"><translate>Company Default</translate></b-form-radio>
            <b-form-radio :value="true">
              <translate>Custom Value:</translate>
              <b-input
                type="number"
                number
                v-model="user.courier_commission_percentage"
                step=".1"
                :disabled="!customVisibleComission"
                class="p-1 d-inline"
                style="width: 5rem; line-height: 1; height: 1.5rem"
                :required="customVisibleComission"
                :state="validPercent"
                :min="0"
                :max="100"
              />%
            </b-form-radio>
          </b-form-radio-group>
        </li>
        <li class="mt-3">
          <b-button size="sm" type="submit" variant="primary" :disabled="!validPercent && customVisibleComission !== false">
            <translate>Set it!</translate>
          </b-button>
        </li>
      </ul>
      </b-alert>
    </form>
  </div>
</template>

<script>
export default {
  emits: ['done'],
  name: 'InAppCommissionForm',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      userVisibleCommission: true,
      customVisibleComission: null,
      editing: false
    }
  },
  computed: {
    currentCommission() {
      if (this.user.courier_commission_percentage !== null) {
        return this.user.courier_commission_percentage + '%'
      }
      return this.user.courier_commission_percentage === null && this.$store.getters.profile.company.courier_commission_percentage ? this.$store.getters.profile.company.courier_commission_percentage + '%' : this.$gettext('Hidden')
    },
    validPercent() {
      if (!this.customVisibleComission) {
        return null
      } else if (this.user.courier_commission_percentage >= 0 && this.user.courier_commission_percentage <= 100) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    editing(val) {
      if (val === true) {
        this.userVisibleCommission = true
        this.customVisibleComission = this.user.courier_commission_percentage !== null
      }
    }
  },
  methods: {
    setCourierCommissionPercentage() {
      const payload = {
        courier_commission_percentage: !this.userVisibleCommission ? 0 : (this.userVisibleCommission && !this.customVisibleComission ? null : this.user.courier_commission_percentage)
      }
      this.$http.patch(this.$appConfig.api.baseUrl + 'companies/users/' + this.user.id, payload)
        .then(response => {
          this.editing = false
          this.emitDone()
        })
    },
    emitDone() {
      this.$emit('done', true)
    }
  }
}
</script>
<style lang="scss" scoped>
  .no-bullet, .no-bullet ul {
    padding: 0;
    margin: 0;
    ul {
      padding: 0 0 0 1.5rem;
    }
    li {
      list-style-type: none;
    }
  }
</style>
